import styled from 'styled-components';
import { variables } from 'components/theme';

export const Wrapper = styled.div`
  display: flex;
  z-index: 5;

  button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    -webkit-tap-highlight-color: transparent;
  }

  @media (min-width: 768px) {
    position: relative;
  }
`;

export const Ul = styled.ul`
  position: absolute;
  box-sizing: border-box;
  border-radius: 11px;
  box-shadow: 0 11px 27px rgba(0, 0, 0, 0.16);
  background-color: ${variables.colors.white};
  padding: 7px 0;
  width: ${props =>
    typeof props.width === 'number' ? `${props.width}px` : props.width};
  white-space: normal;
  font-size: 14px;
  font-weight: 400;
  overflow-y: auto;
  transition: opacity 0.2s ease-in;
  max-height: 400px;
  top: ${props => props.top}px;
  left: ${props => {
    if (typeof props.left === 'string') {
      return props.left;
    }
    if (typeof props.width === 'number') {
      return `calc(100% - ${(props.width * 9) / 10}px)`;
    } else {
      return `0px`;
    }
  }}; /* It works */
  opacity: ${props => props.opacity};
  display: ${props => (props.opacity === 0 ? 'none' : 'block')};
  z-index: 15;

  .active {
    background-color: ${variables.colors.grey12};
  }

  /* li:last-child {
    margin-bottom: 14px;
  } */

  .sub-title {
    padding: 7px 21px 7px 28px !important;
    border-bottom: 1px solid ${variables.colors.grey12};
  }

  li {
    display: block;
    position: relative;

    div {
      cursor: pointer;
    }

    @media (min-width: 768px) {
      padding: 7px 28px;
    }

    @media (max-width: 768px) {
      padding: 14px 28px 14px 35px;
      border-radius: 0px;
    }

    .active,
    :focus,
    :active,
    :hover {
      background-color: ${variables.colors.grey12};
    }

    p {
      color: ${variables.colors.grey16};
      font-size: 12px;
    }
  }
  @media (max-width: 768px) {
    border-radius: 0px;
  }
`;

export const H5 = styled.h5`
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  img {
    margin-right: 14px;
  }
`;

export const SubWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    border: none;
    background-color: transparent;
    color: ${variables.colors.grey4};
    ${variables.fonts.openSansRegular};
  }

  svg {
    margin-top: 1px;
  }
`;
